import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/auth.php';

const IconMail    = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconArrow   = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

export default function RecuperarPassword() {
  const [email,    setEmail]    = useState('');
  const [enviado,  setEnviado]  = useState(false);
  const [error,    setError]    = useState('');
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!email.includes('@')) { setError('Ingresa un email válido'); return; }
    setCargando(true);
    try {
      const r = await fetch(`${API}?action=recuperar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.toLowerCase().trim() }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setEnviado(true);
    } catch(err) {
      setError(err.message || 'Error al enviar el correo');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-blob auth-blob--a"/>
        <div className="auth-blob auth-blob--b"/>
        <div className="auth-grid" aria-hidden="true"/>
      </div>
      <div className="auth-container">
        <Link to="/" className="auth-logo">
          <span className="auth-logo__dot"/>Comunicar
        </Link>
        <div className="auth-card">
          {enviado ? (
            <div style={{textAlign:'center',padding:'1rem 0'}}>
              <div style={{width:64,height:64,background:'#d4f4e8',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 1.2rem'}}>
                <svg viewBox="0 0 24 24" fill="none" width="32" height="32"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="#4db88a" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="#4db88a" strokeWidth="2" strokeLinecap="round"/></svg>
              </div>
              <h2 style={{fontFamily:'inherit',fontSize:'1.3rem',marginBottom:'.7rem'}}>¡Revisa tu correo!</h2>
              <p style={{color:'#5a6a63',fontSize:'.9rem',lineHeight:1.7,marginBottom:'1.5rem'}}>
                Si existe una cuenta con <strong>{email}</strong>, recibirás un enlace para restablecer tu contraseña en los próximos minutos.
              </p>
              <Link to="/login" className="auth-submit" style={{display:'inline-flex',textDecoration:'none',justifyContent:'center'}}>
                Volver al login <IconArrow/>
              </Link>
            </div>
          ) : (
            <>
              <div className="auth-card__head">
                <h1>Recuperar contraseña</h1>
                <p>Ingresa tu correo y te enviaremos un enlace para restablecerla.</p>
              </div>
              {error && <div className="auth-error">{error}</div>}
              <form className="auth-form" onSubmit={handleSubmit} noValidate>
                <div className="auth-field">
                  <label>Correo electrónico</label>
                  <div className="auth-field__wrap">
                    <span className="auth-field__icon"><IconMail/></span>
                    <input
                      type="email" placeholder="tu@correo.com"
                      value={email} onChange={e=>setEmail(e.target.value)}
                      autoComplete="email" required
                    />
                  </div>
                </div>
                <button type="submit" className="auth-submit" disabled={cargando}>
                  {cargando ? <><IconSpinner/> Enviando…</> : <>Enviar enlace <IconArrow/></>}
                </button>
              </form>
              <div className="auth-footer">
                <Link to="/login" className="auth-back">
                  <svg viewBox="0 0 20 20" fill="none" width="14" height="14"><path d="M16 10H4M9 14l-5-4 5-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  Volver al login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}